/**
 * Studio Ode — Product thumbnail click-sync.
 *
 * Our CSS overrides (display:grid on the thumb Swiper wrapper,
 * transform:none, custom overflow) can confuse Swiper's built-in
 * `thumbs` plugin, so this module wires an explicit click handler
 * on every thumbnail that navigates the main product slider via
 * slideTo(). Runs for all `[data-ode-thumb-mode]` products.
 *
 * The thumb column itself is sticky and natively scrollable — no
 * arrow buttons needed. This script just keeps click→main in sync.
 */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.product[data-ode-thumb-mode]').forEach(wireClickSync);
  }

  function wireClickSync(productEl) {
    var mainList = productEl.querySelector('.js-media-list');
    var subList  = productEl.querySelector('.js-media-sublist');
    if (!mainList || !subList) return;

    var thumbs = subList.querySelectorAll('.product__media-subitem');
    var mains  = mainList.querySelectorAll('.product__media-item');

    thumbs.forEach(function (thumb, idx) {
      if (thumb.dataset.odeThumbWired === '1') return;
      thumb.dataset.odeThumbWired = '1';
      thumb.style.cursor = 'pointer';

      thumb.addEventListener('click', function () {
        var subId = thumb.getAttribute('data-media-sub-id') || '';
        var mediaId = subId.split('-').slice(-1)[0];
        var targetIndex = idx;
        if (mediaId) {
          for (var i = 0; i < mains.length; i++) {
            var mainId = mains[i].getAttribute('data-media-id') || '';
            if (mainId.split('-').slice(-1)[0] === mediaId) {
              targetIndex = i;
              break;
            }
          }
        }
        if (mainList.swiper && typeof mainList.swiper.slideTo === 'function') {
          mainList.swiper.slideTo(targetIndex);
        } else {
          var slide = mains[targetIndex];
          if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('.product[data-ode-thumb-mode]').forEach(wireClickSync);
  });
})();
